import Weight from "./pages/weight";
import HeaderPage from "./pages/header-page";

function AppWeight() {
    return (
        <>
            <HeaderPage />
            <Weight />
        </>
    );
};

export default AppWeight;